import type { PriceEntity } from '@components/PriceChart/utils/types';
export default function InversePriceHistory(data: PriceEntity[]) {
  return data.reduce(
    (a: PriceEntity[], b: PriceEntity, i, arr): PriceEntity[] => {
      const nextEntity = arr[i + 1];
      const lastEntity = arr[i - 1];
      // If the close on this date is null
      if (b.close === null) {
        let close: number | null = null;
        // If this is the first entry
        if (i === 0) {
          // Find the first non null close ahead
          const firstNonNullClose = arr.find((n) => n.close !== null);
          close = firstNonNullClose ? firstNonNullClose.close : close;
          return [
            ...a,
            {
              date: b.date,
              close,
            },
          ];
        }
        // If the close on this date is null and this isn't the first entry
        if (i > 0) {
          // Get the previous close from the source data
          close = lastEntity.close;
          // If that close is null
          if (close === null && a.length > 0) {
            // Get the previous close from the acc data
            close = a[a.length - 1].close;
          }
          return [
            ...a,
            {
              date: b.date,
              close,
            },
          ];
        }
      } else {
        // If the close on this date is not null
        if (nextEntity) {
          const nextClose = nextEntity.close;
          // Check if the next one is and save this close and return the output
          if (nextClose === null) {
            return [
              ...a,
              {
                ...b,
              },
            ];
          }
        }
        if (lastEntity) {
          const lastClose = lastEntity.close;
          // Else check if the last one was and save this close and return the output
          if (lastClose === null) {
            return [
              ...a,
              {
                ...b,
              },
            ];
          }
        }
      }
      // Else, whatever, move on
      return [
        ...a,
        {
          date: b.date,
          close: null,
        },
      ];
    },
    []
  );
}
